// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"4401e830","453":"4ef9ef69"}[chunkId] + ".chunk.js";
};